import React from 'react';
import { Switch, Route, Redirect } from 'react-router-dom';

import BasePage from '@ts-core/pages/BasePage';

import CoursesPage from 'modules/courses/pages/CoursesPage';
import CoursePage from 'modules/courses/pages/CoursePage';
import MessagePage from 'modules/messages/pages/MessagePage';
import MessagesPage from 'modules/messages/pages/MessagesPage/MessagesPage';

import StudentNavigationBarContainer from 'core/components/StudentNavigationBarContainer';

import StudentProfilePage from 'modules/account/pages/StudentProfilePage/StudentProfilePage';
import TermsAndConditionsDialog from 'modules/account/components/TermsAndConditionsDialog';
import { useStudentAuth } from 'modules/account/hooks';

const StudentPrivateSection = () => {
  const { user, isAuthenticated } = useStudentAuth();

  if (!isAuthenticated) {
    return <Redirect to="/login" />;
  }

  if (user?.mustChangePassword && user.resetPasswordToken) {
    return <Redirect to={`/set-new-password?token=${user.resetPasswordToken}`} />;
  }

  return (
    <>
      <StudentNavigationBarContainer />
      <BasePage>
        <TermsAndConditionsDialog />
        <Switch>
          <Route path="/courses" exact component={CoursesPage} />
          <Route path="/profile" exact component={StudentProfilePage} />
          <Route path="/messages/:messageId" exact component={MessagePage} />
          <Route path="/messages" exact component={MessagesPage} />
          {/* <Route path={NOTIFICATIONS_URL} exact component={StudentNotificationPage} />
          <Route path={SINGLE_NOTIFICATION_URL} exact component={SingleNotificationPanel} /> */}
          <Route path="/:courseId" component={CoursePage} />
          <Redirect to="/courses" />
        </Switch>
      </BasePage>
    </>
  );
};

export default StudentPrivateSection;
